import Vue from 'vue'

import {
  getMatchedComponentsInstances,
  promisify,
  globalHandleError
} from './utils'

import NuxtError from '../layouts/error.vue'
import NuxtLoading from '@/components/molecules/kcs-loading.vue'

import '../static/css/dest/style.css'

import '../static/css/dest/normalize.css'

import '../static/css/dest/customize.css'

import _6f6c098b from '../layouts/default.vue'
import _2d27502e from '../layouts/none.vue'

const layouts = { "_default": _6f6c098b,"_none": _2d27502e }

export default {
  head: {"title":"こくちーずスペース - セミナー会場に最適な公共施設・格安の貸し会議室検索サービス","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, viewport-fit=cover"},{"name":"format-detection","content":"telephone=no"},{"httpEquiv":"X-UA-Compatible","content":"ie=edge"},{"hid":"keywords","name":"keywords","content":"セミナー会場,貸し会議室,公共施設,格安,口コミ,イベントホール,レンタルスペース,コワーキングスペース,商工会議室,ホテル"},{"hid":"description","name":"description","content":"こくちーずスペースは、イベント・セミナーの開催に適した格安セミナー会場（貸し会議室・ホール・レンタルスペース）を所有する全国3,800箇所以上の公共施設、コワーキングスペース、商工会議室、ホテルを掲載！駅近・リーズナブル・格安で安心して利用できる貸し会議室やレンタルスペースを中心にイベントの規模や設備など目的にあった施設を簡単に検索。施設の口コミやコロナウイルスの感染症対策状況、周辺のホテル・旅館などの宿泊施設、ランチ・ディナにおすすめのレストランも紹介。"},{"property":"fb:app_id","content":"584523565495587"},{"property":"og:type","content":"website"},{"hid":"og-title","property":"og:title","content":"こくちーずスペース - セミナー会場に最適な公共施設・格安の貸し会議室検索サービス"},{"hid":"og-image","property":"og:image","content":"https:\u002F\u002Fwww.kokuchspace.com\u002Fimages\u002Fogp_image.png"},{"name":"twitter:site","content":"@kokuchspace"},{"name":"twitter:card","content":"summary"}],"link":[{"rel":"apple-touch-icon-precomposed","sizes":"180x180","href":"https:\u002F\u002Fwww.kokuchspace.com\u002Fico\u002Fapple-touch-icon-180-precomposed.png"},{"rel":"apple-touch-icon-precomposed","sizes":"152x152","href":"https:\u002F\u002Fwww.kokuchspace.com\u002Fico\u002Fapple-touch-icon-152-precomposed.png"},{"rel":"apple-touch-icon-precomposed","sizes":"144x144","href":"https:\u002F\u002Fwww.kokuchspace.com\u002Fico\u002Fapple-touch-icon-144-precomposed.png"},{"rel":"apple-touch-icon-precomposed","sizes":"120x120","href":"https:\u002F\u002Fwww.kokuchspace.com\u002Fico\u002Fapple-touch-icon-120-precomposed.png"},{"rel":"apple-touch-icon-precomposed","sizes":"114x114","href":"https:\u002F\u002Fwww.kokuchspace.com\u002Fico\u002Fapple-touch-icon-114-precomposed.png"},{"rel":"apple-touch-icon-precomposed","sizes":"76x76","href":"https:\u002F\u002Fwww.kokuchspace.com\u002Fico\u002Fapple-touch-icon-76-precomposed.png"},{"rel":"apple-touch-icon-precomposed","sizes":"72x72","href":"https:\u002F\u002Fwww.kokuchspace.com\u002Fico\u002Fapple-touch-icon-72-precomposed.png"},{"rel":"apple-touch-icon-precomposed","href":"https:\u002F\u002Fwww.kokuchspace.com\u002Fico\u002Fapple-touch-icon-57-precomposed.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"192×192","href":"https:\u002F\u002Fwww.kokuchspace.com\u002Fico\u002Fandroid-chrome-icon-192-precomposed.png"},{"rel":"shortcut icon","href":"https:\u002F\u002Fwww.kokuchspace.com\u002Ffavicon.ico"}],"htmlAttrs":{"lang":"ja"},"style":[],"script":[{"async":true,"src":"\u002F\u002Fpagead2.googlesyndication.com\u002Fpagead\u002Fjs\u002Fadsbygoogle.js"},{"innerHTML":"\n      (adsbygoogle = window.adsbygoogle || []).push({\n        google_ad_client: \"ca-pub-5936792356450049\",\n        enable_page_level_ads: false\n      });\n  "},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-0EDJ342CB7","async":true}],"__dangerouslyDisableSanitizers":["script"]},

  render (h, props) {
    const loadingEl = h('NuxtLoading', { ref: 'loading' })

    if (this.nuxt.err && NuxtError.layout) {
      this.setLayout(
        typeof NuxtError.layout === 'function'
          ? NuxtError.layout(this.context)
          : NuxtError.layout
      )
    }

    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [ layoutEl ])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter (el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [ templateEl ])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [
      loadingEl,

      transitionEl
    ])
  },

  data: () => ({
    isOnline: true,

    layout: null,
    layoutName: ''
  }),

  beforeCreate () {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created () {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this
    // add to window so we can listen when ready
    if (process.client) {
      window.$nuxt = this

      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
    // Add $nuxt.context
    this.context = this.$options.context
  },

  mounted () {
    this.$loading = this.$refs.loading
  },
  watch: {
    'nuxt.err': 'errorChanged'
  },

  computed: {
    isOffline () {
      return !this.isOnline
    }
  },

  methods: {
    refreshOnlineStatus () {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },

    async refresh () {
      const pages = getMatchedComponentsInstances(this.$route)

      if (!pages.length) {
        return
      }
      this.$loading.start()

      const promises = pages.map((page) => {
        const p = []

        if (page.$options.fetch) {
          p.push(promisify(page.$options.fetch, this.context))
        }

        if (page.$options.asyncData) {
          p.push(
            promisify(page.$options.asyncData, this.context)
              .then((newData) => {
                for (const key in newData) {
                  Vue.set(page.$data, key, newData[key])
                }
              })
          )
        }

        return Promise.all(p)
      })
      try {
        await Promise.all(promises)
      } catch (error) {
        this.$loading.fail()
        globalHandleError(error)
        this.error(error)
      }
      this.$loading.finish()
    },

    errorChanged () {
      if (this.nuxt.err && this.$loading) {
        if (this.$loading.fail) {
          this.$loading.fail()
        }
        if (this.$loading.finish) {
          this.$loading.finish()
        }
      }
    },

    setLayout (layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      this.layout = layouts['_' + layout]
      return this.layout
    },
    loadLayout (layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      return Promise.resolve(layouts['_' + layout])
    }
  },

  components: {
    NuxtLoading
  }
}
